import type {
  ContactMetier,
  ContactMetierCommune,
  ContactMetierCommuneAssocieeDeleguee,
  ContactMetierPerimetre,
  ContactMetierTerritoire,
} from "models";

function isCommune(contactMetier: ContactMetier): contactMetier is ContactMetierCommune {
  return contactMetier.$type === "commune";
}

function isCommuneAssocieeDeleguee(
  contactMetier: ContactMetier
): contactMetier is ContactMetierCommuneAssocieeDeleguee {
  return contactMetier.$type === "commune-associee-deleguee";
}

function isLikeACommune(
  contactMetier: ContactMetier
): contactMetier is ContactMetierCommune | ContactMetierCommuneAssocieeDeleguee {
  return isCommune(contactMetier) || isCommuneAssocieeDeleguee(contactMetier);
}

function isPerimetre(contactMetier: ContactMetier): contactMetier is ContactMetierPerimetre {
  return contactMetier.$type === "perimetre";
}

function isTerritoire(contactMetier: ContactMetier): contactMetier is ContactMetierTerritoire {
  return contactMetier.$type === "territoire";
}

export const contactsMetiersUtil = {
  isCommune,
  isCommuneAssocieeDeleguee,
  isLikeACommune,
  isPerimetre,
  isTerritoire,
};
